// Cart utility functions
const CART_KEY = 'shophub_cart';

// Get cart from localStorage
export const getCart = () => {
  try {
    const cart = localStorage.getItem(CART_KEY);
    return cart ? JSON.parse(cart) : { items: [], total: 0 };
  } catch (error) {
    console.error('Error reading cart from localStorage:', error);
    return { items: [], total: 0 };
  }
};

// Save cart to localStorage
export const saveCart = (cart) => {
  try {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
  } catch (error) {
    console.error('Error saving cart to localStorage:', error);
  }
};

// Add item to cart
export const addToCart = (product, quantity = 1) => {
  const cart = getCart();
  const existingItem = cart.items.find(item => item.id === product.id);
  
  if (existingItem) {
    existingItem.quantity += quantity;
  } else {
    cart.items.push({ ...product, quantity });
  }
  
  cart.total = cart.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  saveCart(cart);
  return cart;
};

// Remove item from cart
export const removeFromCart = (productId) => {
  const cart = getCart();
  cart.items = cart.items.filter(item => item.id !== productId);
  cart.total = cart.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  saveCart(cart);
  return cart;
};

// Update item quantity
export const updateCartItemQuantity = (productId, quantity) => {
  if (quantity <= 0) {
    return removeFromCart(productId);
  }
  
  const cart = getCart();
  const item = cart.items.find(item => item.id === productId);
  
  if (item) {
    item.quantity = quantity;
    cart.total = cart.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    saveCart(cart);
  }
  
  return cart;
};

// Clear cart
export const clearCart = () => {
  const cart = { items: [], total: 0 };
  saveCart(cart);
  return cart;
};

// Get cart item count
export const getCartItemCount = () => {
  const cart = getCart();
  return cart.items.reduce((count, item) => count + item.quantity, 0);
};

// Get cart summary
export const getCartSummary = () => {
  const cart = getCart();
  return {
    itemCount: getCartItemCount(),
    total: cart.total,
    items: cart.items.length
  };
};